import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_LEAVES_REQUEST = "FETCH_LEAVES_REQUEST";
export const FETCH_LEAVES_SUCCESS = "FETCH_LEAVES_SUCCESS";
export const FETCH_LEAVES_FAILURE = "FETCH_LEAVES_FAILURE";

// Action Creators
export const fetchLeavesRequest = () => ({ type: FETCH_LEAVES_REQUEST });
export const fetchLeavesSuccess = (leaves) => ({
  type: FETCH_LEAVES_SUCCESS,
  payload: leaves,
});
export const fetchLeavesFailure = (error) => ({
  type: FETCH_LEAVES_FAILURE,
  payload: error,
});

// Thunk


export const fetchLeaves = ({
  page = 1,
  limit = 10,
  district = "",
  municipality = "",
  fromDate = "",
  toDate = "",
  search = "",
  designation = "",
  status = "",
} = {}) => {
  return async (dispatch) => {
    dispatch(fetchLeavesRequest());
    const token = localStorage.getItem("token");

    try {
      const queryParams = new URLSearchParams({
        page,
        limit,
        district,
        municipality,
        fromDate,
        toDate,
        search,
        designation,
        status,
      });

      const res = await axios.get(
        `${BASE_URL}/v1/api/admin/getAllLeaves?${queryParams}`,
        { headers: { authorization: token } }
      );

      dispatch(
        fetchLeavesSuccess({
          data: res.data.data,
          meta: res.data.meta,
        })
      );
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch(fetchLeavesFailure(errorMsg));
    }
  };
};


export const UPDATE_LEAVE_STATUS_REQUEST = "UPDATE_LEAVE_STATUS_REQUEST";
export const UPDATE_LEAVE_STATUS_SUCCESS = "UPDATE_LEAVE_STATUS_SUCCESS";
export const UPDATE_LEAVE_STATUS_FAILURE = "UPDATE_LEAVE_STATUS_FAILURE";

export const updateLeaveStatus = (id, status,leaves_status) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_LEAVE_STATUS_REQUEST });
    const token = localStorage.getItem("token");

    try {
      await axios.post(`${BASE_URL}/v1/api/admin/updateLeaveStatus`, { id, status,leaves_status }, {
        headers: { authorization: token },
      });
      dispatch({ type: UPDATE_LEAVE_STATUS_SUCCESS });
      dispatch(fetchLeaves());
    } catch (err) {
      const errorMsg = err?.response?.data?.meta?.message || err.message;
      dispatch({ type: UPDATE_LEAVE_STATUS_FAILURE, payload: errorMsg });
    }
  };
};


export const BULK_UPDATE_LEAVE_STATUS_REQUEST = "BULK_UPDATE_LEAVE_STATUS_REQUEST";
export const BULK_UPDATE_LEAVE_STATUS_SUCCESS = "BULK_UPDATE_LEAVE_STATUS_SUCCESS";
export const BULK_UPDATE_LEAVE_STATUS_FAILURE = "BULK_UPDATE_LEAVE_STATUS_FAILURE";


export const bulkUpdateLeaveStatus = (ids, status) => {
  return async (dispatch) => {
    dispatch({ type: BULK_UPDATE_LEAVE_STATUS_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/admin/bulkUpdateLeaveStatus`,
        { ids, status },
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch({ type: BULK_UPDATE_LEAVE_STATUS_SUCCESS, payload: response.data });
      dispatch(fetchLeaves()); // Refresh the list after update
    } catch (error) {
      dispatch({
        type: BULK_UPDATE_LEAVE_STATUS_FAILURE,
        payload: error?.response?.data?.message || error.message,
      });
    }
  };
};

export const UPDATE_LEAVE_REMARK_REQUEST = "UPDATE_LEAVE_REMARK_REQUEST";
export const UPDATE_LEAVE_REMARK_SUCCESS = "UPDATE_LEAVE_REMARK_SUCCESS";
export const UPDATE_LEAVE_REMARK_FAILURE = "UPDATE_LEAVE_REMARK_FAILURE";


export const updateLeaveRemark = (leaveId, leaves_status) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_LEAVE_REMARK_REQUEST });

    const token = localStorage.getItem("token");

    try {
      await axios.put(
        `${BASE_URL}/v1/api/admin/updateLeaveRemark/${leaveId}`,
        { leaves_status },
        {
          headers: { authorization: token },
        }
      );

      dispatch({ type: UPDATE_LEAVE_REMARK_SUCCESS });
      dispatch(fetchLeaves());
    } catch (err) {
      const errorMsg =
        err?.response?.data?.meta?.message || err.message;

      dispatch({
        type: UPDATE_LEAVE_REMARK_FAILURE,
        payload: errorMsg,
      });
    }
  };
};


export const UPDATE_LEAVE_REQUEST = "UPDATE_LEAVE_REQUEST";
export const UPDATE_LEAVE_SUCCESS = "UPDATE_LEAVE_SUCCESS";
export const UPDATE_LEAVE_FAILURE = "UPDATE_LEAVE_FAILURE";

export const updateLeave = ({
  leave_id,
  status,
  start_date,
  end_date,
}) => {
  return async (dispatch) => {
    dispatch({ type: UPDATE_LEAVE_REQUEST });

    const token = localStorage.getItem("token");

    try {
      await axios.put(
        `${BASE_URL}/v1/api/admin/updateLeave`,
        {
          leave_id,
          status,
          start_date,
          end_date,
        },
        {
          headers: {
            authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch({ type: UPDATE_LEAVE_SUCCESS });

      toast.success("Leave updated successfully ✅");

      // refresh list
      dispatch(fetchLeaves());

    } catch (err) {
      const errorMsg =
        err?.response?.data?.meta?.message || err.message;

      toast.error(errorMsg);

      dispatch({
        type: UPDATE_LEAVE_FAILURE,
        payload: errorMsg,
      });
    }
  };
};